module.exports = require('./helpers/bundle-url').getBundleURL('byUka') + "connect-with-manara-right.35041739.jpeg" + "?" + Date.now();